module.exports = __webpack_public_path__ + "static/media/base_impact_fitness.1398ebe4.png";